import PropTypes from "prop-types";
import React, { Component } from "react";
import Label from "components/Global-2016/Forms/Label";
import resolveRecordName from "components/Event/Module/utils/resolveRecordName";
import CSSModules from "react-css-modules";
import css from "./styles.scss";
import { Dropdown } from "components/Base";
import { MODES } from "../../../../constants";

@CSSModules(css)
class Sidebar extends Component {
  onReplyToChange = e => this.props.updateReplyTo(e.target.value);

  render() {
    const {
      mode,
      records,
      onOptionSelect,
      options,
      selectedOptions,
      replyTo,
      moduleId
      // toggleGroupByRecipient,
      // groupByRecipient
    } = this.props;
    const recordName = resolveRecordName({ moduleId, plural: false });
    const recordNamePluralLowercase = resolveRecordName({
      moduleId,
      plural: true
    }).toLowerCase();
    const recordNameLowercase = recordName.toLowerCase();
    // const showGroupEmailsToggle = moduleId !== STANDARD_MODULE_IDS.orders.id;

    return (
      <div className={css.sidebarContainer}>
        <div className={css.line}>
          <div className={css.selectedRecords}>
            <i className="material-icons">filter_list</i>
            {` ${records.length} selected ${
              records.length > 1
                ? recordNamePluralLowercase
                : recordNameLowercase
            }`}
          </div>
        </div>
        <div className={css.line}>
          <Label>
            <span className={css.label}>Send to:</span>
          </Label>
          <Dropdown
            onChange={onOptionSelect}
            options={options}
            value={selectedOptions}
          />
        </div>

        {mode === MODES.EMAIL ? (
          <div className={css.line}>
            <Label>
              <span className={css.label}>Replies sent to:</span>
            </Label>
            <input
              className={css.replyEmail}
              type="text"
              name="from"
              onChange={this.onReplyToChange}
              value={replyTo}
            />
          </div>
        ) : null}

        {/*
        // @NOTE: Disabling from UI for now. Can restore if we need it.
        {showGroupEmailsToggle ? (
          <div className={css.line}>
            <Label>
              <span
                className={css.label}
                style={{
                  marginRight: 10
                }}
              >
                Group {mode === MODES.SMS ? "messages" : "emails"} by recipient:
              </span>
              <Tooltip
                message={`If enabled, the records you've selected will be grouped by the ${
                  mode === MODES.SMS ? "phone number" : "email address"
                } of the recipient. You can disable this if you want a recipient to receive multiple ${
                  mode === MODES.SMS ? "messages" : "emails"
                }.`}
                placement="bottom"
              />
            </Label>
            <SmallToggle
              active={groupByRecipient}
              onClick={toggleGroupByRecipient}
            />
          </div>
        ) : null}
        */}
      </div>
    );
  }
}

Sidebar.propTypes = {
  records: PropTypes.array.isRequired,
  options: PropTypes.shape({
    optionType: PropTypes.string,
    optionName: PropTypes.string,
    fieldId: PropTypes.string
  }).isRequired,
  selectedOptions: PropTypes.shape({
    optionType: PropTypes.string,
    optionName: PropTypes.string,
    fieldId: PropTypes.string
  }).isRequired,
  onOptionSelect: PropTypes.func.isRequired,
  updateReplyTo: PropTypes.func.isRequired,
  replyTo: PropTypes.string.isRequired,
  moduleId: PropTypes.string.isRequired
};

export default Sidebar;
